import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-navy" data-id="element-48" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-49" data-mp="1uy2xkxid372q">
        <h2 className="font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-50" data-mp="1v05w65xky8j2">
          Stop choosing. <span className="text-gold" data-id="element-51" data-mp="1q1m5xtbyeakw">Start coaching from a system.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-52" data-mp="1l29ojo3upvpp">
          Macro-cycle, metabolic, strength, adaptation, coaching, retention.
          Decided, dated, printable.
        </p>

        <div className="mt-7" data-id="element-53" data-mp="1c5qwsf7cwdup">
          <Countdown size="sm" tone="dark" data-id="element-54" data-mp="1790i9wb79qbe" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-55" data-mp="17ala3e64qv5k">
          <div data-id="element-56" data-mp="xaaxnvrx5rrg">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-gold" data-id="element-57" data-mp="xbvq9fuob0mo">Complete package</span>
            <span className="text-[15px] font-bold text-white" data-id="element-58" data-mp="3ve3up6vxu6bc">Bootcamp Ready — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-59" data-mp="42ke5ad8i8j1">
            <span className="text-[15px] text-white/60 line-through" data-id="element-60" data-mp="3lijzynt41do6">$97</span>
            <span className="font-display text-4xl leading-none text-white" data-id="element-61" data-mp="3qfiwfd08xwpj">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-62" data-mp="i1tr81658mis">
          <CtaButton data-id="element-63" data-mp="mzlhyrv1y2le">Yes, I want Bootcamp Ready — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-64" data-mp="mxiuaehdglju">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-65" data-mp="czun2p2kxlks">
              <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-66" data-mp="2ssadnprmr1r8" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}